function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from 'eventemitter3';
import { TextEditor } from './TextEditor';
import { WhiteboardKeys } from '../WhiteboardKeys';
const ANCHOR_STYLE = {
  tl: 'cursor:nw-resize;top:-3px;left:-3px',
  t: 'cursor:n-resize;top:-3px;left:50%;translate:-50%;',
  tr: 'cursor:ne-resize;top:-3px;right:-3px',
  l: 'cursor:w-resize;top:50%;left:-3px',
  r: 'cursor:e-resize;top:50%;right:-3px',
  bl: 'cursor:sw-resize;bottom:-3px;left:-3px',
  b: 'cursor:s-resize;bottom:-3px;left:50%;translate:-50%;',
  br: 'cursor:se-resize;bottom:-3px;right:-3px'
};
class Bounds extends EventEmitter {
  get width() {
    return this.maxX - this.minX;
  }
  get height() {
    return this.maxY - this.minY;
  }
  get midX() {
    return this.minX + this.width / 2;
  }
  get midY() {
    return this.minY + this.height / 2;
  }
  constructor(binding, scope) {
    super();
    _defineProperty(this, "minX", 0);
    _defineProperty(this, "minY", 0);
    _defineProperty(this, "maxX", 0);
    _defineProperty(this, "maxY", 0);
    _defineProperty(this, "binding", void 0);
    _defineProperty(this, "scope", void 0);
    this.binding = binding;
    this.scope = scope;
  }
  updateBinding() {
    // 在一次鼠标按下到抬起过程中, 编辑框的左上角可能发生了变化
    // 例如: 编辑框的左上角拖到了比右下角更下的位置, 对于矩阵变换来说没有影响
    // 但是 css 样式需要用实际的最小坐标
    const minX = Math.min(this.minX, this.maxX);
    const maxX = Math.max(this.minX, this.maxX);
    const minY = Math.min(this.minY, this.maxY);
    const maxY = Math.max(this.minY, this.maxY);
    this.binding.style.left = `${minX}px`;
    this.binding.style.top = `${minY}px`;
    this.binding.style.width = `${maxX - minX}px`;
    this.binding.style.height = `${maxY - minY}px`;
  }
  pageCenter() {
    const rect = this.binding.getBoundingClientRect();
    return [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }
  update(minX, minY, maxX, maxY) {
    this.minX = minX;
    this.minY = minY;
    this.maxX = maxX;
    this.maxY = maxY;
    this.updateBinding();
  }
  translate(offsetX, offsetY) {
    const matrix = new this.scope.Matrix();
    this.minX += offsetX;
    this.minY += offsetY;
    this.maxX += offsetX;
    this.maxY += offsetY;
    this.updateBinding();
    const zoom = this.scope.project.view.zoom;
    matrix.translate(offsetX / zoom, offsetY / zoom);
    this.emit('matrix', matrix);
  }
  offsetBy(anchor, offsetX, offsetY, aspectRatio) {
    const matrix = new this.scope.Matrix();
    const prevWidth = this.width;
    const prevHeight = this.height;
    if (anchor === 'tl') {
      if (aspectRatio > 0) {
        offsetY = offsetX / aspectRatio;
      }
      this.minY += offsetY;
      this.minX += offsetX;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.maxX, this.maxY)));
    } else if (anchor === 't') {
      if (aspectRatio > 0) {
        offsetX = offsetY * aspectRatio;
      } else {
        offsetX = 0;
      }
      this.minX += offsetX;
      this.minY += offsetY;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.maxX, this.maxY)));
    } else if (anchor === 'tr') {
      if (aspectRatio > 0) {
        offsetY = -1 * offsetX / aspectRatio;
      }
      this.minY += offsetY;
      this.maxX += offsetX;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.minX, this.maxY)));
    } else if (anchor === 'l') {
      if (aspectRatio > 0) {
        offsetY = offsetX / aspectRatio;
      } else {
        offsetY = 0;
      }
      this.minY += offsetY;
      this.minX += offsetX;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.maxX, this.maxY)));
    } else if (anchor === 'r') {
      if (aspectRatio > 0) {
        offsetY = -1 * offsetX / aspectRatio;
      } else {
        offsetY = 0;
      }
      this.maxX += offsetX;
      this.minY += offsetY;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.minX, this.maxY)));
    } else if (anchor === 'bl') {
      if (aspectRatio > 0) {
        offsetY = -1 * offsetX / aspectRatio;
      }
      this.minX += offsetX;
      this.maxY += offsetY;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.maxX, this.minY)));
    } else if (anchor === 'b') {
      if (aspectRatio > 0) {
        offsetX = -1 * offsetY * aspectRatio;
      } else {
        offsetX = 0;
      }
      this.minX += offsetX;
      this.maxY += offsetY;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.maxX, this.minY)));
    } else if (anchor === 'br') {
      if (aspectRatio > 0) {
        offsetY = offsetX / aspectRatio;
      }
      this.maxY += offsetY;
      this.maxX += offsetX;
      matrix.scale(this.width / prevWidth, this.height / prevHeight, this.scope.project.view.viewToProject(new this.scope.Point(this.minX, this.minY)));
    }
    this.updateBinding();
    this.emit('matrix', matrix);
  }
  reset() {
    const minX = Math.min(this.minX, this.maxX);
    const maxX = Math.max(this.minX, this.maxX);
    const minY = Math.min(this.minY, this.maxY);
    const maxY = Math.max(this.minY, this.maxY);
    this.minX = minX;
    this.maxX = maxX;
    this.minY = minY;
    this.maxY = maxY;
  }
}
export class Editor extends EventEmitter {
  constructor(scope, shadowScope, shadowEmitter, canvasElement, camera, initConfig) {
    super();
    _defineProperty(this, "rootView", void 0);
    _defineProperty(this, "frame", void 0);
    _defineProperty(this, "rotator", void 0);
    _defineProperty(this, "scope", void 0);
    _defineProperty(this, "shadowScope", void 0);
    _defineProperty(this, "shadowContainer", void 0);
    _defineProperty(this, "ctrlUserMap", void 0);
    // 当前是谁的视角
    _defineProperty(this, "viewerId", void 0);
    // 谁在操控 Editor
    _defineProperty(this, "ctrlId", void 0);
    _defineProperty(this, "ctrlNickName", void 0);
    _defineProperty(this, "editMode", null);
    _defineProperty(this, "editCtrlName", null);
    _defineProperty(this, "editAnchor", null);
    _defineProperty(this, "lastEditPoint", null);
    _defineProperty(this, "bounds", void 0);
    _defineProperty(this, "targets", []);
    _defineProperty(this, "editorConfig", null);
    _defineProperty(this, "aspectRatio", -1);
    // 是否等比缩放, 设置后只会应用一次, 即 pointerup 之后会恢复为 false
    _defineProperty(this, "uniformScale", false);
    _defineProperty(this, "camera", void 0);
    _defineProperty(this, "canvasElement", void 0);
    _defineProperty(this, "resizeObserver", void 0);
    _defineProperty(this, "anchors", []);
    _defineProperty(this, "title", null);
    _defineProperty(this, "shadowEmitter", void 0);
    _defineProperty(this, "handleMatrix", matrix => {
      if (this.shadowContainer) {
        const next = matrix.appended(this.shadowContainer.data.shadowMatrix ?? new this.shadowScope.Matrix());
        this.shadowContainer.data.shadowMatrix = next;
        this.shadowContainer.transform(this.shadowContainer.matrix.inverted());
        this.shadowContainer.matrix = next;
      } else {
        this.targets.forEach(target => target.appendPointsMatrix(matrix));
      }
    });
    _defineProperty(this, "handlePointerDown", evt => {
      if (!evt.target) {
        return;
      }
      this.shadowEmitter.setActive(true);
      this.translateShadow();
      const target = evt.target;
      const anchorType = target.getAttribute('data-anchor');
      if (anchorType) {
        evt.preventDefault();
        if (evt.metaKey || this.editorConfig?.uniformScale()) {
          this.uniformScale = true;
        }
        if (this.uniformScale) {
          this.aspectRatio = this.bounds.width / this.bounds.height;
        }
        this.editMode = 'matrix';
        this.editAnchor = anchorType;
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
        this.hiddenCtrlPoints();
      }
      if (target.getAttribute('data-rotator')) {
        evt.preventDefault();
        this.editMode = 'rotate';
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
        this.rootView.style.opacity = '0';
      }
      if (target === this.frame && this.editorConfig?.translatable()) {
        evt.preventDefault();
        this.editMode = 'translate';
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
        this.hiddenCtrlPoints();
      }
      if (target === this.rootView) {
        this.emit('clear');
      }
      const ctrlName = target.getAttribute('data-ctrl-name');
      if (ctrlName) {
        evt.preventDefault();
        this.editMode = 'ctrl-point';
        this.editCtrlName = ctrlName;
        this.lastEditPoint = {
          x: evt.offsetX,
          y: evt.offsetY
        };
      }
    });
    _defineProperty(this, "handlePointerMove", evt => {
      evt.preventDefault();
      if (!evt.target) {
        return;
      }
      if (this.editMode === 'matrix' && this.editAnchor && this.lastEditPoint) {
        const offsetX = evt.pageX - this.lastEditPoint.x;
        const offsetY = evt.pageY - this.lastEditPoint.y;
        this.bounds.offsetBy(this.editAnchor, offsetX, offsetY, this.uniformScale ? this.aspectRatio : -1);
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
      }
      if (this.editMode === 'rotate' && this.lastEditPoint) {
        const pageCenter = this.bounds.pageCenter();
        const vector1 = new this.scope.Point(this.lastEditPoint.x, this.lastEditPoint.y).subtract(new this.scope.Point(pageCenter));
        const vector2 = new this.scope.Point(evt.pageX, evt.pageY).subtract(new this.scope.Point(pageCenter));
        const viewPoint = new this.scope.Point(this.bounds.midX, this.bounds.midY);
        const projectPoint = this.scope.project.view.viewToProject(viewPoint);
        this.targets.forEach(target => {
          if (target.item) {
            target.rotateByOffset(vector2.angle - vector1.angle, projectPoint.x, projectPoint.y);
          }
        });
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
      }
      if (this.editMode === 'translate' && this.lastEditPoint) {
        const offsetX = evt.pageX - this.lastEditPoint.x;
        const offsetY = evt.pageY - this.lastEditPoint.y;
        this.bounds.translate(offsetX, offsetY);
        this.updateBoundsByShadow();
        this.lastEditPoint = {
          x: evt.pageX,
          y: evt.pageY
        };
      }
      if (this.editMode === 'ctrl-point' && this.editorConfig) {
        const ctrlPoint = this.editorConfig.controlPoints.find(v => v.name === this.editCtrlName);
        const ctrlElement = this.rootView.querySelector(`[data-ctrl-name="${this.editCtrlName}"]`);
        if (ctrlPoint && ctrlElement) {
          const projectPoint = this.scope.project.view.getEventPoint(evt);
          ctrlPoint.onPositionChange(projectPoint);
          this.updateBoundsByShadow();
          this.updateControlPointsPosition();
        }
      }
    });
    _defineProperty(this, "handlePointerUp", evt => {
      evt.preventDefault();
      this.resetShadow();
      this.shadowEmitter.setActive(false);
      this.updateBounds();
      if (this.editMode === 'rotate') {
        this.applyConfig(this.editorConfig);
        this.rootView.style.opacity = '1';
      }
      if (this.editMode === 'matrix') {
        this.bounds.reset();
      }
      this.editMode = null;
      this.editAnchor = null;
      this.lastEditPoint = null;
      this.uniformScale = false;
    });
    _defineProperty(this, "handleFrameDBClick", evt => {
      if (evt.target === this.frame && this.targets.length === 1) {
        if (this.targets[0].type === 'point-text') {
          this.frame.style.display = 'none';
          this.createTextEditor(this.targets[0]);
        }
      }
    });
    _defineProperty(this, "updateBounds", () => {
      let minX = Number.MAX_VALUE;
      let maxX = -Number.MAX_VALUE;
      let minY = Number.MAX_VALUE;
      let maxY = -Number.MAX_VALUE;
      for (const model of this.targets) {
        if (!model.item) {
          continue;
        }
        const bound = model.item.bounds;
        minX = Math.min(bound.topLeft.x, minX);
        maxX = Math.max(bound.bottomRight.x, maxX);
        minY = Math.min(bound.topLeft.y, minY);
        maxY = Math.max(bound.bottomRight.y, maxY);
      }
      const fromPoint = new this.scope.Point(minX, minY).transform(this.scope.project.view.matrix);
      const toPoint = new this.scope.Point(maxX, maxY).transform(this.scope.project.view.matrix);
      this.bounds.update(fromPoint.x, fromPoint.y, toPoint.x, toPoint.y);
      this.updateControlPointsPosition();
    });
    this.shadowEmitter = shadowEmitter;
    this.shadowScope = shadowScope;
    this.shadowContainer = new shadowScope.Group();
    this.shadowContainer.applyMatrix = false;
    this.shadowContainer.data.uuid = `shadow-container-${initConfig.ctrlId}`;
    this.canvasElement = canvasElement;
    this.camera = camera;
    this.scope = scope;
    this.ctrlUserMap = initConfig.ctrlUserMap;
    this.viewerId = initConfig.viewerId;
    this.ctrlId = initConfig.ctrlId;
    this.ctrlNickName = initConfig.ctrlNickName;
    this.rootView = document.createElement('div');
    this.rootView.style.cssText = 'overflow:hidden;position:absolute;display:none;width:100%;height:100%;top:50%;left:50%;transform:translate(-50%,-50%);';
    this.frame = document.createElement('div');
    this.frame.style.position = 'absolute';
    this.frame.style.padding = '8px';
    this.frame.style.transform = 'translate(-8px, -8px)';
    this.rootView.appendChild(this.frame);
    this.bounds = new Bounds(this.frame, this.scope);
    this.bounds.on('matrix', this.handleMatrix);
    this.rotator = document.createElement('div');
    this.rotator.setAttribute('data-rotator', 'true');
    if (this.viewerId === this.ctrlId) {
      this.frame.style.cursor = 'all-scroll';
      this.rootView.addEventListener('pointerdown', this.handlePointerDown);
      this.rootView.addEventListener('pointermove', this.handlePointerMove);
      this.rootView.addEventListener('pointerup', this.handlePointerUp);
      this.createAnchor();
      this.frame.appendChild(this.rotator);
      this.frame.addEventListener('dblclick', this.handleFrameDBClick);
    } else {
      this.title = document.createElement('div');
      this.title.textContent = `${this.ctrlNickName}`;
      this.title.style.cssText = 'color:#fff;font-size:12px;padding: 0.2em 0.4em;border-radius: 0.4em;position: absolute;top: 0%;left: 0;margin: -0.4em;transform: translate(-100%, -100%);';
      this.frame.appendChild(this.title);
      this.rootView.style.pointerEvents = 'none';
    }
    this.resizeObserver = new ResizeObserver(() => {
      this.alignRootView();
    });
    this.resizeObserver.observe(this.canvasElement);
    this.alignRootView();
  }
  alignRootView() {
    const rect = this.canvasElement.getBoundingClientRect();
    this.rootView.style.width = `${rect.width}px`;
    this.rootView.style.height = `${rect.height}px`;
  }
  hiddenCtrlPoints() {
    this.editorConfig?.controlPoints.forEach(ctrl => {
      const ctrlElement = this.rootView.querySelector(`[data-ctrl-name="${ctrl.name}"]`);
      if (ctrlElement) {
        ctrlElement.style.opacity = '0';
      }
    });
  }
  createTextEditor(target) {
    const measurement = target.getInternalMeasurement();
    if (!measurement) {
      return;
    }
    const textEditor = new TextEditor(this.camera);
    textEditor.setOrigin(measurement.topLeft.x, measurement.topLeft.y);
    textEditor.setRotate(measurement.angle);
    textEditor.setContent(target.content);
    textEditor.setFontFamily(target.fontFamily);
    textEditor.setFontSize(target.fontSize * measurement.scaleX);
    this.rootView.appendChild(textEditor.rootView);
    this.camera.triggerZoom();
    target.shadow = 'layer';
    textEditor.on('change', content => {
      target.content = content;
    });
    textEditor.on('done', () => {
      target.shadow = '';
      textEditor.dispose();
      this.rootView.removeChild(textEditor.rootView);
    });
    setTimeout(() => {
      textEditor.focus();
      textEditor.setCaret();
    }, 30);
  }
  createAnchor() {
    // @ts-ignore
    Object.keys(ANCHOR_STYLE).forEach(key => {
      const anchor = document.createElement('div');
      anchor.setAttribute('data-anchor', key);
      anchor.style.cssText = `width:6px;height:6px;position:absolute;${ANCHOR_STYLE[key]}`;
      this.frame.appendChild(anchor);
      this.anchors.push(anchor);
    });
  }
  setAnchorsVisiblity(targets, visible) {
    targets.forEach(t => {
      const element = document.querySelector(`[data-anchor='${t}']`);
      if (element) {
        element.style.display = visible ? 'block' : 'none';
      }
    });
  }
  updateControlPointsPosition() {
    if (this.editorConfig) {
      this.editorConfig.controlPoints.forEach(ctrl => {
        const pos = ctrl.getPosition();
        const ctrlElement = this.rootView.querySelector(`[data-ctrl-name="${ctrl.name}"]`);
        if (ctrlElement) {
          ctrlElement.style.top = `${pos.y}px`;
          ctrlElement.style.left = `${pos.x}px`;
          ctrlElement.style.opacity = '1';
        }
      });
    }
  }
  createControlPoint(config) {
    const div = document.createElement('div');
    div.setAttribute('data-ctrl-name', config.name);
    const pos = config.getPosition();
    div.style.cssText = `position:absolute;top:${pos.y}px;left:${pos.x}px;width:8px;height:8px;background:#FFC107;border-radius:50%;padding:4px;background-clip:content-box;transform:translate(-8px,-8px);`;
    this.rootView.appendChild(div);
  }
  removeAllControlPoints() {
    const elements = this.rootView.querySelectorAll('[data-ctrl-name]');
    Array.from(elements).forEach(element => {
      this.rootView.removeChild(element);
    });
  }
  applyConfig(cfg) {
    this.editorConfig = cfg;
    this.setAnchorsVisiblity(['tl', 't', 'tr', 'l', 'r', 'bl', 'b', 'br'], true);
    if (!cfg) {
      return;
    }
    if (cfg.resizeModel() === 'four') {
      this.setAnchorsVisiblity(['tl', 'tr', 'bl', 'br'], false);
    } else if (cfg.resizeModel() === 'four-corner') {
      this.setAnchorsVisiblity(['t', 'l', 'r', 'b'], false);
    } else if (cfg.resizeModel() === 'horizontal') {
      this.setAnchorsVisiblity(['tl', 't', 'tr', 'bl', 'b', 'br'], false);
    }
    this.removeAllControlPoints();
    if (this.viewerId === this.ctrlId) {
      for (const controlPoint of cfg.controlPoints) {
        this.createControlPoint(controlPoint);
      }
    }
  }
  setTargets(models) {
    if (models.length <= 0) {
      return;
    }
    this.frame.style.display = 'block';
    this.targets = models;
    let config = null;
    for (const model of models) {
      if (!model.item) {
        continue;
      }
      if (config) {
        config = config.merge(model.editorConfig());
      } else {
        config = model.editorConfig();
      }
    }
    this.applyConfig(config);
    this.updateBounds();
  }
  updateBoundsByShadow() {
    let minX = Number.MAX_VALUE;
    let maxX = -Number.MAX_VALUE;
    let minY = Number.MAX_VALUE;
    let maxY = -Number.MAX_VALUE;
    const bounds = this.shadowContainer.bounds;
    minX = Math.min(bounds.topLeft.x, minX);
    maxX = Math.max(bounds.bottomRight.x, maxX);
    minY = Math.min(bounds.topLeft.y, minY);
    maxY = Math.max(bounds.bottomRight.y, maxY);
    const fromPoint = new this.shadowScope.Point(minX, minY).transform(this.shadowScope.project.view.matrix);
    const toPoint = new this.shadowScope.Point(maxX, maxY).transform(this.shadowScope.project.view.matrix);
    this.bounds.update(fromPoint.x, fromPoint.y, toPoint.x, toPoint.y);
  }
  translateShadow() {
    this.shadowContainer.removeChildren();
    this.shadowContainer.remove();
    this.shadowScope.project.activeLayer.addChild(this.shadowContainer);
    this.targets.forEach(model => {
      model.shadow = this.shadowContainer.data.uuid;
    });
  }
  resetShadow() {
    const matrix = this.shadowContainer.data.shadowMatrix;
    this.targets.forEach(target => {
      target.shadow = '';
      if (matrix) {
        target.appendPointsMatrix(matrix);
      }
    });
    this.shadowContainer.transform(this.shadowContainer.matrix.inverted());
    this.shadowContainer.data.shadowMatrix = null;
  }
  hidden() {
    this.resetShadow();
    this.rootView.style.display = 'none';
    this.targets = [];
    this.editorConfig = null;
    if (this.ctrlId !== this.viewerId) {
      if (this.scope.project.view) {
        this.scope.project.view.off('frame', this.updateBounds);
      }
    }
  }
  show() {
    const themeColor = this.ctrlUserMap.get(WhiteboardKeys.themeColor);
    this.frame.style.border = `1px solid ${themeColor}`;
    this.rotator.style.cssText = `cursor:grab;position:absolute;width:8px;height:8px;border-radius:50%;border:1px solid ${themeColor};top:-22px;left:50%;translate:-50%;`;
    this.anchors.forEach(anchor => {
      anchor.style.background = themeColor;
    });
    if (this.title) {
      this.title.style.background = themeColor;
    }
    if (this.ctrlId !== this.viewerId) {
      this.scope.project.view.on('frame', this.updateBounds);
    }
    this.rootView.style.display = 'block';
  }
  dispose() {
    this.resizeObserver.disconnect();
  }
}